import { css } from "styled-components";

import {
  ElementFlexProps,
  ElementInnerSpacingType,
  ElementOuterSpacingType,
  ElementSpacingType,
} from "./types";

export const elementInnerSpacingMixin = css<ElementInnerSpacingType>`
  padding-top: ${({ $pt }) => $pt};
  padding-bottom: ${({ $pb }) => $pb};
  padding-left: ${({ $pl }) => $pl};
  padding-right: ${({ $pr }) => $pr};
`;

export const elementOuterSpacingMixin = css<ElementOuterSpacingType>`
  margin-top: ${({ $mt }) => $mt};
  margin-bottom: ${({ $mb }) => $mb};
  margin-left: ${({ $ml }) => $ml};
  margin-right: ${({ $mr }) => $mr};
`;

export const elementSpacingMixin = css<ElementSpacingType>`
  ${elementInnerSpacingMixin};
  ${elementOuterSpacingMixin};
`;

export const elementFlexMixin = css<ElementFlexProps>`
  ${({ $flex }) => $flex && `flex-direction: ${$flex};`}
  ${({ $align }) => $align && `align-items: ${$align};`}
  ${({ $justify }) => $justify && `justify-content: ${$justify};`}
  ${({ $gap }) => $gap && `gap: ${$gap};`}
`;
